<template>
    <div class="area_form">
        <div class="area_form_body">
            <div class="area_row">
                <div class="area_col_head"><label>연번</label></div>
                <div class="area_col_body">
                    <div class="">
                        <p v-text="state.data.number"></p>
                    </div>
                </div>
            </div>

            <div class="area_row">
                <div class="area_col_head"><label>담당 상담원</label></div>
                <div class="area_col_body">
                    <div class="">
                        <p v-text="state.data.counselor"></p>
                    </div>
                </div>
            </div>

            <div class="area_row">
                <div class="area_col_head"><label>성매매 유형</label></div>
                <div class="area_col_body">
                    <div class="">
                        <p v-text="state.data.type"></p>
                    </div>
                </div>
            </div>

            <div class="area_row">
                <div class="area_col_head"><label>주민등록번호</label></div>
                <div class="area_col_body">
                    <div class="">
                        <p v-text="CommonUtils.convertJumin(state.data.clientDetailVO.jumin)"></p>
                    </div>
                </div>
            </div>

            <div class="area_row">
                <div class="area_col_head"><label>연락처</label></div>
                <div class="area_col_body">
                    <div class="">
                        <p v-text="CommonUtils.convertPhoneNum(state.data.clientDetailVO.phone)"></p>
                    </div>
                </div>
            </div>

            <div class="area_row">
                <div class="area_col_head"><label>상담 부서</label></div>
                <div class="area_col_body">
                    <div class="">
                        <p v-text="state.data.consultDepartment"></p>
                    </div>
                </div>
            </div>

            <div class="area_row noPrint">
                <div class="area_col_head"><label>첨부파일</label></div>
                <div class="area_col_body">
                    <div class="area_file">
                        <label for="area_file">
                            <input id="area_file" type="file" placeholder="" multiple @change="handleFiles" />

                            <div class="file_box_wrap">파일 첨부하기</div>
                            <span class="file_upload_btn">파일첨부</span>
                            <p class="p_info">※200M 이하 파일을 첨부해주세요.</p>
                        </label>
                    </div>
                </div>
            </div>

            <div class="area_row noPrint">
                <div class="area_col_head"><label>첨부파일목록</label></div>
                <div class="area_col_body">
                    <div class="file_list">
                        <div class="file" v-for="(item, idx) in state.data.fileList" :key="idx">
                            <div class="file_name" @click="downloadFile(item.file, item.realName)">
                                <img src="img/file_ico.png" alt="" />
                                <span class="">{{ item.realName }}</span>
                                <img src="img/file_down_ico.png" alt="" class="noPrint" />
                            </div>
                            <button class="file_del icon_wrap noPrint" @click="fileRemove(item.idx)">삭제</button>
                        </div>

                        <!-- <div class="file" v-for="(item, index) in state.file" :key="index">
                            <span class="file_name">{{ item.name }}</span>
                            <button class="file_del icon_wrap" @click="removeNewFile(index)">
                                <img src="img/close_02.png" alt="" class="noPrint" />
                            </button>
                        </div> -->
                    </div>
                </div>
            </div>

            <div class="area_row noPrint">
                <div class="area_col_head"><label>녹취파일목록</label></div>
                <div class="area_col_body">
                    <div class="file_list">
                        <div class="file" v-for="(item, idx) in state.data.recordList" :key="idx">
                            <div class="file_name" @click="downloadFile(item.file, '녹취록.txt')">
                                <img src="img/file_ico.png" alt="" />
                                <span class="">{{ item.fileName }}</span>
                                <img src="img/file_down_ico.png" alt="" class="noPrint" />
                            </div>
                            <button class="file_del icon_wrap noPrint" @click="showSummary(item.summaryText)">상세</button>
                            <button class="file_del icon_wrap noPrint" @click="removeSummary(item.idx)">삭제</button>
                        </div>

                        <!-- <div class="file" v-for="(item, index) in state.file" :key="index">
                            <span class="file_name">{{ item.name }}</span>
                            <button class="file_del icon_wrap" @click="removeNewFile(index)">
                                <img src="img/close_02.png" alt="" class="noPrint" />
                            </button>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
</template>
<script lang="ts" config>
    import { reactive, watch, apiService, onMounted, ModalDefault, types, getMessageByCode, CommonUtils, CommonOptions } from "@/BaseComponent";

    export default {
        props: {
            idx: {
                type: Number,
                default: 0,
            },
        },
        components: { ModalDefault },
        setup(props: any) {
            const state = reactive({
                idx: 0 as number,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                data: {
                    clientDetailVO: {} as types.client.ClientDetailVOForApi,
                } as types.client.ClientVOForApi | any,
                file: [] as Array<File>,
            });

            onMounted(() => {
                state.idx = props.idx;
                if (state.idx > 0) detail();
            });

            watch(
                () => props.idx,
                () => {
                    state.idx = props.idx;
                    if (state.idx > 0) detail();
                },
            );

            const closeModal = () => {
                state.isShowModal = false;
            };

            const callBackModal = async (param: any) => {};

            const detail = async () => {
                const res: types.client.ResClient = await apiService.client.detail(state.idx);

                if (res.returnCode === 0) {
                    state.data = res.data;

                    // Object.assign(state, state.data);
                    if (state.data != null) {
                        state.data = res.data;
                    } else {
                        state.data = {};
                    }
                } else {
                    state.data = {};
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const handleFiles = (e: any) => {
                const target = e.target as HTMLInputElement;
                if (!target.files) return;

                const files: File[] = Array.from(target.files);
                state.file = files;
                addFile();
                target.value = "";
            };

            const addFile = async () => {
                const param: types.client.ReqFile = {
                    file: state.file,
                };
                const res = await apiService.client.addFile(state.idx, param);
                if (res.returnCode === 0) {
                    state.file = [];
                    detail();
                } else {
                    console.error(res.description);
                }
            };

            const fileRemove = async (idxFile: number) => {
                const res = await apiService.client.removeForFile(state.idx, idxFile);
                if (res.returnCode === 0) {
                    const index = state.data.fileList.findIndex((item: any) => item.idx === idxFile);
                    if (index !== -1) {
                        state.data.fileList.splice(index, 1);
                    }
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = 8;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const removeNewFile = (index: number) => {
                state.file.splice(index, 1);
            };

            const downloadFile = async (fileUrl: string, fileName: string) => {
                const res = await fetch(fileUrl);
                const blob = await res.blob();
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                URL.revokeObjectURL(link.href);
            };

            const showSummary = (summaryText: string) => {
                if (summaryText) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = summaryText.replaceAll("\n", "</br>");
                    state.isShowModal = true;
                }
            };

            const removeSummary = async (idx: number) => {
                const res = await apiService.clientRecord.modify(idx, 0);
                if (res.returnCode === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "처리 되었습니다.";
                    state.isShowModal = true;
                    await detail();
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            return {
                state,

                CommonUtils,
                CommonOptions,
                closeModal,
                callBackModal,
                handleFiles,
                downloadFile,
                fileRemove,
                removeNewFile,
                showSummary,
                removeSummary,
            };
        },
    };
</script>

<style scoped>
    .file_list {
        overflow-y: auto;
        max-height: 100px;
    }
</style>
